import { IHeaderParams } from "ag-grid-community";
import { ReactComponent as GearRegularIcon } from "../../assets/icons/gear-regular.svg";
import useBillingStore from "../../stores/billing-store/billing-store";
import { TReceiptEntity } from "../../types/billing";

type HeaderProps = IHeaderParams<TReceiptEntity>;

const ReceiptHeaderComponent = ({ displayName }: HeaderProps) => {
  const { setShowCounterPopup } = useBillingStore();

  return (
    <>
      <div className="flex justify-between items-center uppercase text-11 text-neutral-4 font-700 w-full">
        <div>{displayName}</div>
        <GearRegularIcon
          className="h-16 w-16 text-darwin-neutral-400 cursor-pointer"
          onClick={() => {
            setShowCounterPopup(true);
          }}
        />
      </div>
    </>
  );
};

export default ReceiptHeaderComponent;
